import React from "react"
import {FieldPickerProps} from "../../render/picker";

export default function FieldProto_Picker(props: FieldPickerProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.picker</div>
    )

}